import { QIcon_caf_accuracy, QIcon_caf_complexity, QIcon_caf_fluency, QIcon_caf_pronunciation } from '@repo/icons/index'
import { useRouter } from 'next/router'
import { n_caf } from '../../../../i18n/strings/auto/wording_webview'
import useTranslation from '../../../../i18n/useTranslation'
import { COLORS } from '../../../../vars'
import { getRoundValue } from '../chart/utilFunction'
import findWordingKey from './findWordingKey'

const highlightsTitle = {
  13: [n_caf.highlight.category13, (props) => <QIcon_caf_complexity {...props} />],
  14: [n_caf.highlight.category14, (props) => <QIcon_caf_complexity {...props} />],
  15: [n_caf.highlight.category15, (props) => <QIcon_caf_fluency {...props} />],
  16: [n_caf.highlight.category16, (props) => <QIcon_caf_fluency {...props} />],
  17: [n_caf.highlight.category17, (props) => <QIcon_caf_complexity {...props} />],
  18: [n_caf.highlight.category18, (props) => <QIcon_caf_pronunciation {...props} color={COLORS.PURPLE500} />],
  grammar_error: [n_caf.highlight.grammar_category, (props) => <QIcon_caf_accuracy {...props} />],
}

const tooltipWordings = {
  13: n_caf.highlight.modal_repetition,
  14: n_caf.highlight.modal_runon,
  15: n_caf.highlight.modal_speech_rate,
  16: n_caf.highlight.modal_filler_word,
  17: n_caf.highlight.modal_sentence_structure,
  18: n_caf.highlight18.tool_tip,
}
/**
 * @param average  : 00개 / 평균 00개 - 워딩을 다르게 사용하기 위한 flag
 */
const useMapTagToWording = (isNotAverage = false) => {
  const { t } = useTranslation()
  const router = useRouter()

  const isTagGrammarError = (tag: number) => {
    if (tag <= 12) return true
    return false
  }
  const namePerTag = (tag: number) => {
    // Grammar Errors(0~12)
    if (isTagGrammarError(tag)) {
      return t(highlightsTitle['grammar_error'][0] as any)
    }
    // Others (13~)
    if (highlightsTitle[tag]) {
      return t(highlightsTitle[tag][0])
    }
  }

  /**
   *  00개 있었어요.
   */
  const countWordingPerTag = (tag: number, count?: number) => {
    const wKeyWrong = ['highlight', 'correct', `grammar${tag}`] // 하이라이트 카운트가 없을 경우 워딩.

    const wKeyCorrect = isNotAverage
      ? ['highlight', 'error', `grammar${tag}`] // 하이라이트 카운트가 있을 경우 워딩.
      : ['statistic', 'highlight', `grammarerror${tag}`] // 하이라이트 카운트를 평균으로 보여줄 경우 워딩.

    return {
      count: t(
        findWordingKey(n_caf, {
          key: wKeyCorrect,
          params: [getRoundValue(count)],
        })
      ),
      noCount: t(
        findWordingKey(n_caf, {
          key: wKeyWrong,
        })
      ),
    }
  }

  const tooltipWordingPerTag = (tag: number) => {
    return tooltipWordings[tag] ? t(tooltipWordings[tag]) : ''
  }

  const iconPerTag = (tag: number) =>
    highlightsTitle[tag] ? highlightsTitle[tag][1] : highlightsTitle['grammar_error'][1]
  return { namePerTag, countWordingPerTag, iconPerTag, tooltipWordingPerTag }
}

export default useMapTagToWording
